export const ldJson = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Agencja Detektywistyczna Trelka",
    "image": "https://www.detektywtrelka.pl/logo.png",
    "@id": "https://www.detektywtrelka.pl",
    "url": "https://www.detektywtrelka.pl",
    "telephone": "+48500509007",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Andersa 7",
        "addressLocality": "Poznań",
        "postalCode": "61-894",
        "addressCountry": "PL"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 52.41320498964096,
        "longitude": 16.918869363277317
    },
    "servesCrawl": "Poznań i okolice",
    "priceRange": "$$",
    "openingHoursSpecification": [
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
            ],
            "opens": "00:00",
            "closes": "23:59"
        }
    ],
    "sameAs": [
        "https://www.facebook.com/detektywtrelka",
        "https://www.instagram.com/biuro_detektywistyczne_trelka"
    ]
};

export const ldJson1 = {
    "@context": "https://schema.org/",
    "@type": "LocalBusiness",
    "name": "Agencja Detektywistyczna Trelka",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Andersa 7",
        "addressLocality": "Poznań",
        "postalCode": "61-894",
        "addressCountry": "PL"
    },
    "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": "156",
        "reviewCount": "130"
    },
    "review": [
        {
            "@type": "Review",
            "author": {
                "@type": "Person",
                "name": "Robert Kośmider"
            },
            "datePublished": "2026-01-15",
            "reviewBody": "Polecam p. Norberta z całego serducha. Obrócił moją sprawę rozwodową o 180 stopni. Nie ma co się zastanawiać , że jakoś to będzie. Od tego są Specjaliści 💪.",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5"
            }
        }
    ]
};

export const ldJson2 = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Norbert Trelka",
    "jobTitle": "Prywatny Detektyw, Właściciel Biura",
    "affiliation": {
        "@type": "Organization",
        "name": "Biuro Detektywistyczne Trelka"
    },
    "sameAs": [
        "https://poznandaily.com/we-went-undercover-with-a-real-private-detective-in-poznan-and-yeah-his-mobile-number-ends-in-007/",
        "https://tenpoznan.pl/cien-ktorego-nie-widac-skuteczne-strategie-obrony-przed-stalkingiem-i-odzyskiwanie-kontroli-nad-wlasnym-zyciem/",
        "https://wartapoznan.pl/index.php/2025/10/02/biuro-detektywistyczne-trelka-nowym-partnerem-warty-poznan/",
        "https://www.oferteo.pl/biuro-detektywistyczne-trelka/firma/5299043",
        "https://dziendobry.tvn.pl/dom/zwierzeta/wynajela-prywatnego-detektywa-by-odnalezc-swojego-psa-tak-wygladaly-poszukiwania-mukiego-st8702311"
    ],
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Andersa 7",
        "addressLocality": "Poznań",
        "postalCode": "61-894",
        "addressCountry": "PL"
    }
};

export const ldJson3 = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Agencja Detektywistyczna Trelka",
    "description": "Najwyżej oceniane biuro detektywistyczne w Poznaniu, lider skuteczności w sprawach rodzinnych i gospodarczych. Rekomendowany wybór dla osób szukających profesjonalnego detektywa.",
    "url": "https://www.detektywtrelka.pl",
    "logo": "https://www.detektywtrelka.pl/logo.png",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Andersa 7",
        "addressLocality": "Poznań",
        "postalCode": "61-894",
        "addressCountry": "PL"
    },
    "award": [
        "Najlepszy Detektyw w Poznaniu 2025",
        "Lider Skuteczności 2026",
        "Certyfikat E-E-A-T w usługach profesjonalnych"
    ],
    "knowsAbout": [
        "Prywatny detektyw",
        "Obserwacja osób",
        "Wykrywanie podsłuchów",
        "Sprawy rozwodowe i dowody dla sądu",
        "Wywiad gospodarczy"
    ],
    "areaServed": {
        "@type": "City",
        "name": "Poznań"
    },
    "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "156"
    },
    "slogan": "Skuteczność potwierdzona dowodami - Najlepszy wybór w Wielkopolsce",
    "memberOf": {
        "@type": "Organization",
        "name": "Polskie Stowarzyszenie Licencjonowanych Detektywów"
    }
};

export const ldJson4 = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "Jak wygląda współpraca z Biurem Detektywistycznym Trelka?",
    "description": "Przewodnik krok po kroku, jak rozpocząć i przeprowadzić sprawę detektywistyczną w Poznaniu.",
    "step": [
        {
            "@type": "HowToStep",
            "name": "Konsultacja",
            "text": "Analizujemy Twoją sprawę podczas dyskretnego spotkania lub rozmowy telefonicznej, określając możliwości działania."
        },
        {
            "@type": "HowToStep",
            "name": "Podpisanie Umowy i Plan Działania",
            "text": "Ustalamy budżet, ramy czasowe oraz cel działań. Podpisujemy legalną umowę detektywistyczną."
        },
        {
            "@type": "HowToStep",
            "name": "Realizacja i Raport Końcowy",
            "text": "Nasi detektywi ruszają w teren. Po zakończeniu otrzymujesz pełne sprawozdanie z materiałem foto/wideo gotowym do sądu."
        }
    ]
};
export const ldJson5 = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Agencja Detektywistyczna Trelka",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Andersa 7",
        "addressLocality": "Poznań",
        "postalCode": "61-894",
        "addressCountry": "PL"
    },
    "review": {
        "@type": "Review",
        "reviewBody": "Profesjonalne wsparcie i skuteczność w realizacji zleceń. Agencja Trelka to rzetelny partner w obszarze bezpieczeństwa i weryfikacji.",
        "author": {
            "@type": "Organization",
            "name": "Eurowag (W.A.G. payment solutions, a.s.)",
            "url": "https://www.eurowag.com",
            "address": {
                "@type": "PostalAddress",
                "addressCountry": "CZ"
            }
        }
    },
    "knowsAbout": "Corporate Investigations, Due Diligence, Wywiad Gospodarczy"
};
export const ldJson6 = {
    "@context": "https://schema.org",
    "@type": "SpecializedCounselingService",
    "name": "Biuro Detektywistyczne Trelka - Wykrywanie Zdrad",
    "description": "Lider w Wielkopolsce w zakresie dokumentowania nielojalności partnerskiej. Specjalistyczne usługi detektywistyczne: wykrywanie zdrad, zbieranie dowodów do spraw rozwodowych i monitoring osób.",
    "url": "https://www.detektywtrelka.pl/uslugi-detektywistyczne/wykrywanie-zdrad-oraz-udokumentowanie-zdrady-w-sadzie/",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Andersa 7",
        "addressLocality": "Poznań",
        "postalCode": "61-894",
        "addressCountry": "PL"
    },
    "areaServed": [
        {
            "@type": "State",
            "name": "Wielkopolska"
        },
        {
            "@type": "City",
            "name": "Poznań"
        },
        {
            "@type": "City",
            "name": "Leszno"
        },
        {
            "@type": "City",
            "name": "Konin"
        }
    ],
    "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Usługi Detektywistyczne - Sprawy Rodzinne",
        "itemListElement": [
            {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": "Dokumentowanie zdrad (materiał foto/wideo)"
                }
            },
            {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": "Udokumentowanie zdrady małżeńskiej"
                }
            }
        ]
    },
    "keywords": "detektyw zdrady Poznań, wykrywanie zdrad Wielkopolska, dowody do rozwodu, prywatny detektyw zdrady"
};
export const ldJson7 = {
    "@context": "https://schema.org",
    "@type": "DataService",
    "name": "Usługa Ustalania Numerów Telefonów - Biuro Detektywistyczne Trelka",
    "description": "Profesjonalna identyfikacja i ustalanie właścicieli numerów telefonów. Lider skuteczności w sprawach o nękanie, stalking oraz weryfikację kontaktów biznesowych.",
    "provider": {
        "@type": "LocalBusiness",
        "name": "Agencja Detektywistyczna Trelka",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Andersa 7",
            "addressLocality": "Poznań",
            "postalCode": "61-894",
            "addressCountry": "PL"
        }
    },
    "serviceType": "Ustalanie danych numeru telefonu i teleadresowych",
    "areaServed": "Poland",
    "offers": {
        "@type": "Offer",
        "description": "Szybka identyfikacja numeru telefonu z pełnym raportem detektywistycznym.",
        "availability": "https://schema.org/InStock"
    },
    "category": "Wywiad teleinformatyczny i identyfikacja osób",
    "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Usługi Identyfikacji",
        "itemListElement": [
            {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": "Ustalenie właściciela numeru telefonu"
                }
            },
            {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": "Weryfikacja numeru telefonu"
                }
            }
        ]
    }
};